var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightArrowGrey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "url(#pattern0_52_21)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_52_21",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_52_21",
    transform: "scale(0.015625)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_52_21",
    width: 64,
    height: 64,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAACXBIWXMAAA7DAAAOwwHHb6hkAAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAAmVJREFUeJztmMFO1FAUhr8zGKLiwtHEne/ASkxvTQSNbzAPYFyqwUVvxxgIxmDQ6SUiL8BLuNCoCwJzF7qfhzHS6wJCyKQNM4Ctredb9m9P/vOluZMpKIqiKIqiKIqiKIryvyF1FzgPaZo+AOaBvcFg8OMsM2YutlJ1JEmyCuwAj4Anxphf3vv9aec0UkCv15vpdrufgNmjSwI8jKLot/d+b5pZnQtvVyMism6tXZnmmUa+AaPRKMRxPAvcL4iXjDHBe787yaxGCgAYDoe7URTdFJE7BfFiFEVXvPffTpvTWAEA3vvPxpgbwMJ4JiLxJBIaLQDOL6HxAuBQQhzHXUokGGOulklohQCA4XD4xRhzHbhbEJsoiua891/Hg9YIAPDel0oQkUIJrRIAx2fCZSAez0TEGGOunZTQOgEA3vvvZRKA6KQEAbDW3gMWRKRVQkIIT4HbJfEgy7K+WGuXga0Ke/1LvOiISL/uFjWSturP0Fno5Hn+ru4SNTIQgH6/Hx8cHCwCczUXulBE5DFwqyQ+PASrLFQl1toN4GVJ7LIss9Dwb4IliLX2A7BcFIYQMudcenxzZbWqYarloV2fxCRN0y1KlgcG48tDe94AsdZ+BJ4XhSGE9865wvOgDQLOvDzApb9WqxokSZJt4FlReNry0OwzQJIk2RaRsuVfn7Y8NPgNSNN0LYRQuDyw5px7M8mcRgro9XozIYSkJF7Nsmx90lmNFFBGCGHFOfd2mmca+QFkNBoFY0wHWDq6lAOvnHMb085q9M9gmqaLIYT5PM/3Nzc3f9bdR1EURVEURVEURVGUZvAHv7zZzE+K+1sAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrowGrey);
export default __webpack_public_path__ + "static/media/right_arrow_grey.d513024ad5b31e3e6855fea15f5b970d.svg";
export { ForwardRef as ReactComponent };